// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type IPaginatedRequest = {
  fields?: string
  orderBy?: string
  page?: number
  perPage?: number
  search?: string
  format?: string
  ouName?: string
  appid?: string
}

export enum Format {
  csv,
  xlsx
}

export interface IProductivityReportRequest {
  employeeId?: string
  startDate?: Date
  endDate?: Date
  mechanic?: string
  year?: number
  reportType?: string
}

export interface IPaginatedRequestWholsaler {
  fields?: string
  orderBy?: string
  page?: number
  perPage?: number
  search?: string
  format?: string
  WholesalerUUID?: string
  TemplateUUID?: string
}

export interface IPaginatedRequestKeyloopWorkOrders {
  PageNo?: number
  PageSize?: number
  SearchField: string
  SearchValue: string
}

export interface IPostKeyloopTransferBasket {
  workOrderUUID: string
  jobUUID: string
}

export interface IUpdateWorkOrderReference {
  workOrderUUID: string
  orderReference: string
}
